// Your simplified JavaScript code goes here
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.debouncedSubmit = debounce(() => {
      this.updateURL();
    }, 800);

    // Listen to form changes
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', this.debouncedSubmit);
      form.addEventListener('change', this.debouncedSubmit);
    }

    // Handle sort dropdown immediate submission
    const sortSelects = this.querySelectorAll('select[name="sort_by"]');
    sortSelects.forEach((select) => {
      select.addEventListener('change', () => {
        this.updateURL();
      });
    });

    // Handle active filter removal
    this.addEventListener('click', (event) => {
      if (event.target.closest('facet-remove')) {
        event.preventDefault();
        this.removeActiveFilter(event);
      }
    });
  }

  updateURL() {
    const form = this.querySelector('form');
    if (!form) return;

    const formData = new FormData(form);
    const params = new URLSearchParams();

    // Add all form data to URL params
    for (const [key, value] of formData.entries()) {
      if (value && value.trim() !== '') {
        params.append(key, value);
      }
    }

    // Update URL and refresh page
    const newURL = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
    window.location.href = newURL;
  }

  removeActiveFilter(event) {
    const removeElement = event.target.closest('facet-remove');
    const link = removeElement.querySelector('a');

    if (link && link.href) {
      window.location.href = link.href;
    }
  }

  static initialize() {
    // Handle browser back/forward buttons
    window.addEventListener('popstate', () => {
      window.location.reload();
    });
  }
}

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input').forEach((input) => {
      input.addEventListener('change', this.handleChange.bind(this));
      input.addEventListener('keydown', this.handleKeyDown.bind(this));
    });

    this.setMinMaxConstraints();
  }

  handleChange(event) {
    this.validateInput(event.target);
    this.setMinMaxConstraints();

    // Trigger form update
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event('change', {bubbles: true}));
    }
  }

  handleKeyDown(event) {
    // Allow: backspace, delete, tab, escape, enter, arrows, numbers, decimal
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown'
    ];

    const allowedChars = /[0-9.,]/;

    if (
      allowedKeys.includes(event.key) ||
      allowedChars.test(event.key) ||
      event.metaKey ||
      event.ctrlKey
    ) {
      return;
    }

    event.preventDefault();
  }

  validateInput(input) {
    const value = parseFloat(input.value) || 0;
    const min = parseFloat(input.getAttribute('min')) || 0;
    const max = parseFloat(input.getAttribute('max')) || Infinity;

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  setMinMaxConstraints() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (minInput && maxInput) {
      if (minInput.value) {
        maxInput.setAttribute('min', minInput.value);
      }
      if (maxInput.value) {
        minInput.setAttribute('max', maxInput.value);
      }
    }
  }
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const link = this.querySelector('a');
    if (link) {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = link.href;
      });

      link.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          window.location.href = link.href;
        }
      });
    }
  }
}

// Initialize everything
customElements.define('facet-filters-form', FacetFiltersForm);
customElements.define('price-range', PriceRange);
customElements.define('facet-remove', FacetRemove);

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  FacetFiltersForm.initialize();
});
